import React from 'react';

import classes from './styles.module.css';

export default function Logo({ style }) {
    function renderLogo(val) {
        switch (val) {
            case 'wl':
                return <div className={classes.WL} style={style} />;
            case 'unlimco':
                return <div className={classes.Unlimco} style={style} />;
            case 'eclear':
                return <div className={classes.Eclear} style={style} />;
            default:
                return <div className={classes.Eclear} style={style} />;
        }
    }

    return renderLogo((typeof process !== 'undefined' && process.env && process.env.BRAND) || 'eclear');
}



// WEBPACK FOOTER //
// ./src/Components/Logo/index.js